/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_ITEM(state, item) {
    item.category = JSON.stringify( item.category )
    item.pages = JSON.stringify( item.pages )
    state.products.unshift(item)
  },
  SET_DEMOS(state, products) {
    if(products == 'undefined'){
      state.products = []
    }else{
      state.products = products
    }

  },
  // SET_LABELS(state, labels) {
  //   state.eventLabels = labels
  // },
  UPDATE_DEMO(state, product) {
    product.category = JSON.stringify( product.category )
    product.pages = JSON.stringify( product.pages )
      const productIndex = state.products.findIndex((p) => p.id == product.id)
      Object.assign(state.products[productIndex], product)

  },
  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.products.findIndex((p) => p.id == itemId)
      state.products.splice(ItemIndex, 1)
  },
}
